import * as $ from 'jquery';
window.$ = window.jQuery = $ || {};
const botBubble = require('../img/chat-icon.svg');
const botCoin = require('../img/chat-icon.svg');
const btSend = require('../img/send-icon.svg');
const btClose = require('../img/close-icon.svg');

$(function () {
  if ($('luknator-container').length == 0) {
    var divLuknator = $('<div class="luknator-content" style="display:block;"><luknator-container /></div>');
    $('body').append(divLuknator);
  }

  window.luknatorParams = {
    title: "Tire suas dúvidas",
    url: "https://luknator.luizalabs.com/v1/pme/pme/",
    bot_bubble: botBubble,
    bot_coin: botCoin,
    bt_send: btSend,
    bt_close: btClose
  };

  $.getScript("https://s3.amazonaws.com/luknator-cdn/js/luknator-mvc.js");
})
